export class ApplicationApplicantDto {
    id: number;
    name: string;
    firstName: string;
    lastName: string;
    strAddr: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    altPhone: string;
    fax: string;
    email: string;
    type: string;
    sign: boolean;
    notNotarized: boolean;
    public create() {
        return {
            id: 0,
            name: '',
            firstName: '',
            lastName: '',
            strAddr: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            altPhone: '',
            fax: '',
            email: '',
            type: '',
            sign: false,
            notNotarized: false
        }
    };
}
